import './rangeChoice.css';

function RangeChoice(props) {
    return (
        <div className={`range-choice`}>
            <div className={'range-choice-title'}>Dans un rayon de :</div>
            <div className={'range-choice-container'}>
                <input className={'range-choice-container-item range-choice-input'} onChange={props.handleRangeChange} onTouchEnd={props.handleRangeUp} onMouseUp={props.handleRangeUp} type="range" id="location-range" value={props.value} step={2} name="location-range" min="1" max="1000" />
                <span className={'km-value range-choice-container-item'}>{props.value}km</span>
            </div>
        </div>
    );
}

export default RangeChoice;
